export default __webpack_public_path__ + "static/pragicts-automation-services-workflow-automation-4db316bc4ff5eb938afdbce1a9cd9c41.jpg";